import { FC, PropsWithChildren, useState } from 'react';
import { Alert, Collapse, Stack, Typography } from '@mui/material';

import { Button } from '@components/base';

const ParsingError: FC<PropsWithChildren> = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Alert icon={false} severity='error'>
      <Stack>
        <Stack direction='row' justifyContent='space-between' spacing={1}>
          <Typography gutterBottom variant='inherit'>
            Could not parse metadata
          </Typography>

          <Button
            color='inherit'
            onClick={() => setExpanded(prev => !prev)}
            rightIcon={expanded ? 'expandLess' : 'expandMore'}
          >
            {expanded ? 'hide raw' : 'show raw'}
          </Button>
        </Stack>
        <Collapse in={expanded}>{children}</Collapse>
      </Stack>
    </Alert>
  );
};

export default ParsingError;
